import { MagicBallAPI } from './api/MagicBallAPI';

function showError(message: string): void {
  let overlay = document.getElementById('error-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.id = 'error-overlay';
    overlay.style.cssText =
      'position:fixed;bottom:0;left:0;right:0;max-height:40vh;overflow-y:auto;' +
      'background:rgba(120,0,0,0.92);color:#fff;font:11px monospace;' +
      'padding:10px;z-index:9999;white-space:pre-wrap;';
    document.body.appendChild(overlay);
  }
  overlay.textContent += message + '\n\n';
}

window.addEventListener('error', (e) => {
  showError(`Error: ${e.message}\n  at ${e.filename}:${e.lineno}:${e.colno}`);
});
window.addEventListener('unhandledrejection', (e) => {
  showError(`Unhandled rejection: ${e.reason?.stack ?? e.reason}`);
});

function showLoading(): HTMLDivElement {
  const el = document.createElement('div');
  el.style.cssText =
    'position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);' +
    'color:#888;font:14px system-ui;z-index:100;';
  el.textContent = 'Loading…';
  document.body.appendChild(el);
  return el;
}

async function main(): Promise<void> {
  const canvas = document.getElementById('viewport') as HTMLCanvasElement;
  if (!canvas) throw new Error('Canvas #viewport not found');

  const loading = showLoading();
  try {
    const api = new MagicBallAPI(canvas);
    await api.init();
  } catch (err) {
    showError(`Init failed: ${(err as Error)?.stack ?? err}`);
    throw err;
  } finally {
    loading.remove();
  }
}

main().catch(console.error);
